interface WavyLineDecorationProps {
  colorLight: string
  colorDark: string
  height?: number
  bottom?: number
  opacity?: number
}

export function WavyLineDecoration({
  colorLight,
  colorDark,
  height = 224,
  bottom = 14,
  opacity = 1,
}: WavyLineDecorationProps) {
  return (
    <div
      className="pointer-events-none absolute left-0 z-[1] w-full"
      style={{
        height,
        bottom,
        background: `linear-gradient(180deg, ${colorLight} 0%, ${colorDark} 100%)`,
        maskImage: 'url(/images/lmp-line.svg)',
        WebkitMaskImage: 'url(/images/lmp-line.svg)',
        maskSize: 'cover',
        WebkitMaskSize: 'cover',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        opacity,
      }}
    />
  )
}
